/**
 * Created by Admin on 2017/9/5.
 */
export default {
  state: {
    data: {},
    checkList: []
  },
  mutations: {},
  actions: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/syncData.js